import {
  ASSET_MANIFEST,
  type AssetPath,
} from "@/types/asset-manifest.generated";

export type { AssetPath };

export function cdn(path: AssetPath): string {
  if (process.env.NODE_ENV !== "production") return `/dev-assets/${path}`;
  return `${process.env.NEXT_PUBLIC_CDN_URL}/${ASSET_MANIFEST[path]}`;
}
